import { ChangeEvent, useCallback, useState } from 'react'
import cn from 'classnames/bind'

import PlainInput, { PlainInputProps, Ref } from './plain-input'

import styles from './plain-input-number.module.scss'

const cx = cn.bind(styles)

type Props = {
  hideArrows?: boolean
} & PlainInputProps

export const PlainInputNumberStateful = ({
  hideArrows,
  inputClassName,
  defaultValue,
  onChange,
  value,
  loading,
  ...others
}: Props) => {
  const isControlled = value !== undefined

  const [currentValue, setCurrentValue] = useState(defaultValue)

  const handleChange = useCallback(
    (e: ChangeEvent<Ref>) => {
      setCurrentValue(e.target.value)
      onChange?.(e)
    },
    [onChange],
  )

  const actualValue = isControlled
    ? value
    : currentValue === undefined
      ? defaultValue
      : currentValue

  return (
    <PlainInput
      type="number"
      inputClassName={cx(inputClassName, { hideArrows })}
      inputmode="numeric"
      {...others}
      value={actualValue}
      onChange={handleChange}
      loading={loading}
    />
  )
}
